import KebabImg from '../assets/png/capriciosa.png';
import PizzaImg from '../assets/png/nduja.png';
import BurgerImg from '../assets/png/funghi.png';
import FriesImg from '../assets/png/crudo.png';

export const menuCategories = ['TUTTI', 'KEBAB', 'PIZZE', 'PANINI', 'FRITTI', 'BEVANDE', 'DOLCI'];

export const menuProducts = [
  {
    id: 1,
    name: 'Kebab in Piadina',
    price: '€7,50',
    description: 'Carne di kebab, insalata, pomodori, cipolla, salsa yogurt',
    category: 'KEBAB',
    image: KebabImg,
  },
  {
    id: 2,
    name: 'Pizza Margherita',
    price: '€8,90',
    description: 'Pomodoro, mozzarella, basilico',
    category: 'PIZZE',
    image: PizzaImg,
  },
  {
    id: 3,
    name: 'Panino BBQ',
    price: '€8,50',
    description: 'Carne di manzo, cheddar, insalata, pomodoro, salsa BBQ',
    category: 'PANINI',
    image: BurgerImg,
  },
  {
    id: 4,
    name: 'Patatine Fritte',
    price: '€3,20',
    description: 'Patatine fritte croccanti e dorate',
    category: 'FRITTI',
    image: FriesImg,
  },
];
